import dayjs from 'dayjs';
import type {SLAM_POINT_CLOUD_STATUS, SlamPointCloud} from '@/domain/entities/SlamPointCloud';
import type {SlamPointCloudDto} from './SlamPointCloudDto';

export const toDto = (domain: SlamPointCloud): SlamPointCloudDto => ({
  uuid: domain.uuid,
  inventoryPlotUuid: domain.inventoryPlotUuid,
  status: domain.status,
  date: domain.date.toISOString(),
  lidarTechnologyUuid: domain.lidarTechnologyUuid,
  comments: domain.comments,
  createdAt: domain.createdAt.toISOString(),
});

export const toDomain = (dto: SlamPointCloudDto): SlamPointCloud => ({
  ...dto,
  date: dayjs(dto.date),
  createdAt: dayjs(dto.date),
  status: dto.status as SLAM_POINT_CLOUD_STATUS,
});
